<template>
  <div class="jikangai">
    <h3>時間外申請</h3>
    <div class="flex">
      <b class="title">月日</b>
      <p>{{ jikangai?.jikangai_date }}</p>
    </div>
    <div class="flex">
      <b class="title">就業場所</b>
      <p>{{ form.syuugyou_basyo_name }}</p>
    </div>
    <div class="flex">
      <b class="title">就業時間</b>
      <p v-if="workTime.length > 0">{{ workTime[0].disp_work_time }}</p>
      <p v-else>無し</p>
    </div>
    <div class="flex">
      <b class="title">開始日時</b>
      <div class="table-item">
        <p>{{ jikangai?.start_date + ' '+ jikangai?.start_time }}</p>
      </div>
    </div>
    <div class="flex">
      <b class="title">終了日時</b>
      <div class="table-item">
        <p>{{ jikangai?.end_date + ' '+ jikangai?.end_time }}</p>
      </div>
    </div>
    <div class="flex">
      <b class="title">医療機関の<br>終了時間</b>
      <p>{{ jikangai?.iin_close_time ?? '無し' }}</p>
    </div>
    <div class="flex">
      <b class="title"><p>業務内容<br>（詳細に）</p></b>
      <p class="pre">{{ jikangai?.gyoumu_notes ?? '無し' }}</p>
    </div>
    <div class="flex">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, watchEffect, Ref, ref } from 'vue';
import { useForm } from '@/composable/form/form';
import { useJikangai } from '@/composable/shinsei/jikangai/jikangai';
import dayjs from 'dayjs'
import { Shinsei, KoyouKeiyakuTimeForDetail } from '@/types/Shinsei';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
    workTime: {
      type: Object as () => KoyouKeiyakuTimeForDetail[],
      default: null
    },
  },
  emits: {
    save: (val: number) => true,
  },
  setup(props) {

    const jikangai = props.form.jikangai;

    // エラー取得
    const { getError } = useForm();
    const { confAlert, selectWorkTime } = useJikangai()
    const workTime = props.workTime

    const dateTimeFormatter = (val: string | null | undefined) => {
      if(!val){
        return
      }
      const date = dayjs(val).format('YYYY/MM/DD HH:mm')
      return date
    }
    
    const alertStartTime = async () => {
      if(props.form.shinsei_koyou_keiyaku_time.length > 0 && jikangai){

        return confAlert(jikangai)
      }else{
        return true
      }
    }
    watchEffect(() => {
      if(props.workTime && props.form.shinsei_koyou_keiyaku_time.length > 0) {
        const idx = props.workTime.findIndex(v => v.koyou_keiyaku_time_id == props.form.shinsei_koyou_keiyaku_time[0].koyou_keiyaku_time_id)
        if(idx >= 0){
          selectWorkTime.startTime = props.workTime[idx].start_time
          selectWorkTime.endTime = props.workTime[idx].end_time
        }
      }
    })

    return {
      jikangai,
      getError,
      dateTimeFormatter,
      alertStartTime,
      workTime,
    }
  },
  components: {

  }
})

</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>